import React, { Component } from "react";
import { Col, Row, Button, Menu, Drawer } from "antd";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";
import logoOxxo from "../assets/oxxo-r.png";
import "../styles/Header.css";
import { doLogout } from "../redux/actions/Session";
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';

const { SubMenu } = Menu

class Header extends Component {

    constructor(props) {
        super(props)
        this.handleLogout = this.handleLogout.bind(this)
    }

    handleLogout() {
        this.props.doLogout()
    }

    isMobileDevice() {
        return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
    };

    render() {
        const isMobile = this.isMobileDevice();
        let cred = null;
        // let usrs = null;
        let ests = null;

        if (this.props.session && this.props.session.email === "admin@wheeling.com") {
            cred = (
                <Menu.Item style={{ marginLeft: 10 }}>
                    <Link to="/credentials">Credenciales de Carga</Link>
                </Menu.Item>
            )

            // usrs = (
            //     <SubMenu
            //         title={"Usuarios"}
            //         onTitleClick={() => { }}
            //         style={{ marginLeft: 10 }}
            //     >
            //         <Menu.Item>
            //             <Link to="/users">Usuarios</Link>
            //         </Menu.Item>
            //         <Menu.Item>
            //             <Link to="/addUser">Añadir Usuario</Link>
            //         </Menu.Item>
            //     </SubMenu>
            // )

            ests = (
                <SubMenu
                    title={"Estaciones"}
                    onTitleClick={() => { }}
                    style={{ marginLeft: 10 }}
                >
                    <Menu.Item>
                        <Link to="/stations">Estaciones de Carga</Link>
                    </Menu.Item>
                    <Menu.Item>
                        <Link to="/addStation">Crear Estacion</Link>
                    </Menu.Item>
                </SubMenu>
            )
        }

        const menu = (
            <Menu mode="horizontal"
                style={{ 
                    marginTop: isMobile ? 20 : 0,
                }}
            >
                <Menu.Item style={{ marginLeft: 10 }}>
                    <Link to="/">Inicio</Link>
                </Menu.Item>
                {ests}
                <Menu.Item style={{ marginLeft: 10 }}>
                    <Link to="/loads">Cargas</Link>
                </Menu.Item>
                {/* {usrs} */}
                {cred}
                <Menu.Item style={{ marginLeft: 10 }}>
                    <Link to="/"><Button onClick={this.handleLogout}>Cerrar Sesión</Button></Link>
                </Menu.Item>
            </Menu>
        );

        const logos = (
            <div style={{ display: "flex", justifyContent: "space-around", alignContent: "center" }}>
                <a href="/">
                <img src={logo} height="24px" alt="" />
                </a>
                <img src={logoOxxo} height="24px" alt="" />
            </div>
        );

        return (
            <nav className="menuBar">
                {isMobile ?
                    <Row>
                        <Row>
                            <Col span={24}>
                                {logos}
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24} style={{ display: "flex", justifyContent: "space-around", alignContent: "center" }}>
                                {menu}
                            </Col>
                        </Row>
                    </Row>
                    :
                    <Row>
                        <Col span={8} >
                            {logos}
                        </Col>
                        <Col span={16} style={{ display: "flex", justifyContent: "flex-end" }}>
                            {menu}
                        </Col>
                    </Row>
                }
            </nav>
        )
    }
}

const mapStateToProps = state => {
    return { session: state.session.user }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({ doLogout }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)